import { useRouter } from 'next/router'
import { useStoreActions, useStoreState } from 'easy-peasy'
import { useEffect, useState } from 'react'

import NoData from 'components/NoData'

const publicPaths = ['/login']

export default function RouteGuard({ children }) {
  const loggedIn = useStoreState((state) => state.loggedIn)
  const procesosEvaluacion = useStoreState((state) => state.procesosEvaluacion)
  const updateStore = useStoreActions((actions) => actions.updateStore)
  const router = useRouter()
  const [authorized, setAuthorized] = useState(false)

  function authCheck(url) {
    const path = url.split('?')[0]
    if (!loggedIn && !publicPaths.includes(path)) {
      setAuthorized(false)
      router.push({
        pathname: '/login',
      })
    } else {
      setAuthorized(true)
    }
  }

  useEffect(() => {
    authCheck(router.asPath)
    router.events.on('routeChangeComplete', authCheck)
    return () => {
      router.events.off('routeChangeComplete', authCheck)
    }
  }, [router, loggedIn])

  useEffect(() => {
    if (loggedIn && !publicPaths.includes(router.asPath)) {
      updateStore()
    }
  }, [])

  // Un usuario sin procesos de evaluacion asignados no puede renderizar el resto
  // de la app: mas de 50 puntos del codigo asumen que selectedProcesoEvaluacion
  // existe (Main, el dropdown de procesos, dashboard, areas, validar...) y
  // revientan con un TypeError. Se corta aca, por encima de todos ellos.
  // procesosEvaluacion es undefined mientras la consulta esta en vuelo y un
  // arreglo vacio solo cuando ya sabemos que el usuario no tiene ninguno, asi
  // que este chequeo no se dispara durante la carga.
  const sinProcesos = Array.isArray(procesosEvaluacion) && procesosEvaluacion.length === 0
  if (authorized && loggedIn && sinProcesos
    && !publicPaths.includes(router.asPath.split('?')[0])) {
    return <NoData />
  }

  return (authorized && children)
}
